import { WidgetNotAvailableInEnvironment } from 'widgets/WidgetNotAvailable/WidgetNotAvailableInEnvironment';
import { UnknownConfiguration } from './store/UnknownWidgetState';
import { WidgetStrategyWithConfig } from 'widgets/WidgetRegistry';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';

export const unknownWidgetStrategy: WidgetStrategyWithConfig<UnknownConfiguration> =
    {
        title: '',
        reactComponentType: WidgetNotAvailableInEnvironment,
        supportedHosts: ['layout', 'tile'],
        initialConfigState: {},
        categories: [],
        portfolioSelectionRequirements: PortfolioSelectionRequirements.None,
    };
